import React from 'react';
import styled from 'styled-components';

import { Title } from '../Title';
import { Text } from '../Text';
import { breakpoints, colors } from '../../../constants';
import { Logo } from '../../../svg';

const TextContainer = styled.div``;
const ImageContainer = styled.div``;
const HeaderImage = styled.img``;

interface IProps {
    className?: string;
}

const BaseTopSection = ({ className }: IProps) => {
    const image =
        'https://grandvision.s3.amazonaws.com/pnl/images/online-oogcheck/oogcheck-result.jpg';

    return (
        <div className={className}>
            <ImageContainer>
                <HeaderImage src={image} />
                <Logo />
            </ImageContainer>
            <TextContainer>
                <Title>Waar kijkt een opticien naar tijdens een oogtest?</Title>
                <Text>
                    De oogcheck die je net hebt gedaan is natuurlijk geen échte
                    oogmeting. Een online check is niet te vergelijken met een
                    deskundige oogmeting die bij de opticien plaatsvindt. Maar,
                    op deze manier weet je wel waar er op gelet wordt door een
                    opticien, hoe je meer bewust kunt zijn van je zicht én hoe
                    je beter voor je ogen kunt zorgen.
                </Text>
            </TextContainer>
        </div>
    );
};

export const TopSection = styled(BaseTopSection)`
    position: relative;
    display: flex;
    flex-direction: column;
    background-color: ${colors.white};

    ${HeaderImage} {
        height: 100%;
        width: 100%;
        object-fit: cover;
    }

    ${Title}, ${Text} {
        max-width: 700px;

        @media (${breakpoints.mediumMin}) {
            margin-left: auto;
        }
    }

    ${TextContainer} {
        padding: 40px 20px;

        @media (${breakpoints.mediumMin}) {
            padding: 120px 60px 20px 0;
        }
    }

    ${Title} {
        font-size: 32px;
        line-height: 1.2;
        margin-bottom: 40px;
    }

    ${Text} {
        line-height: 2;
    }

    ${ImageContainer} {
        position: relative;
        height: 320px;

        @media (${breakpoints.mediumMin}) {
            height: 100%;
        }
    }

    ${Logo} {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 0);
        width: 30%;
        min-width: 140px;
        max-width: 160px;
        height: auto;

        @media (${breakpoints.mediumMin}) {
            display: none;
        }
    }

    @media (${breakpoints.mediumMin}) {
        height: 560px;
        flex-direction: row-reverse;
        align-items: center;
        justify-content: center;

        ${TextContainer}, ${ImageContainer} {
            width: 50%;
        }
    }
`;
